"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/reports/file");
const Types = require("../../types");
exports.initialState = {
    error: null,
    fileContent: null,
    fileName: null,
    status: Types.STANDBY
};
/* State lenses */
const errorLens = monocle.Lens.fromProp('error');
const fileContentLens = monocle.Lens.fromProp('fileContent');
const fileNameLens = monocle.Lens.fromProp('fileName');
const statusLens = monocle.Lens.fromProp('status');
/* Methods */
exports.methods = {};
exports.methods[ActionTypes.CLEAR_REPORT_FILE] = (_state, _action) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.FETCH_REPORT_FILE_REQUEST] = (state, action) => fp.function.flow(fileNameLens.set(action.payload.fileName), statusLens.set(Types.FETCHING))(state);
exports.methods[ActionTypes.FETCH_REPORT_FILE_SUCCESS] = (state, action) => fp.function.flow(errorLens.set(null), statusLens.set(Types.FETCHED), fileContentLens.set(action.payload))(state);
exports.methods[ActionTypes.FETCH_REPORT_FILE_FAILURE] = (state, action) => fp.function.flow(errorLens.set(action.error), fileContentLens.set(null), statusLens.set(Types.FAILED))(state);
//# sourceMappingURL=file.js.map